import { useCallback, useEffect, useState } from 'react';

import type { AppearanceChoice } from './appearance';
import { browserAppearance } from './appearanceController';

/** The signed-in person's stored choice, and a setter that stores and applies it at once. Copied from studio-fripp. */
export function useAppearanceChoice(
  userId: string | null,
): [AppearanceChoice, (choice: AppearanceChoice) => void] {
  const [choice, setChoice] = useState<AppearanceChoice>(() => storedChoice(userId));

  useEffect(() => {
    setChoice(storedChoice(userId));
  }, [userId]);

  const choose = useCallback(
    (next: AppearanceChoice) => {
      if (userId === null) return;
      browserAppearance().choose(userId, next);
      setChoice(next);
    },
    [userId],
  );

  return [choice, choose];
}

function storedChoice(userId: string | null): AppearanceChoice {
  return userId === null ? 'system' : browserAppearance().choice(userId);
}
